define([
    './NgFormDecorator',
    './EmailInputDecorator'
], (NgFormDecorator, EmailInputDecorator)=> {
    angular.module('edge.platform.decorator', [])
        .config(['$provide', NgFormDecorator])
        .config(['$provide', EmailInputDecorator]);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/decorator/module.js
 **/